export { getExcelTemplateName } from "./excel-template-names";

export function download(response, defaultFileName = "download") {
  let fileName = defaultFileName;
  const downloadLink = document.createElement("a");
  const href = URL.createObjectURL(response.data);

  downloadLink.href = href;

  if (defaultFileName === "download") {
    const disposition = response.headers["content-disposition"];

    if (disposition && disposition.indexOf("attachment") !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);

      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, "");
      }
    }
  }

  downloadLink.download = fileName;

  document.body.appendChild(downloadLink);

  downloadLink.click();

  downloadLink.parentNode.removeChild(downloadLink);
  URL.revokeObjectURL(href);
}

export function downloadPdf(data, fileName) {
  const downloadLink = document.createElement("a");
  const href = URL.createObjectURL(data);

  downloadLink.href = href;

  const disposition = "application/pdf";

  downloadLink.download = fileName;

  document.body.appendChild(downloadLink);

  downloadLink.click();

  downloadLink.parentNode.removeChild(downloadLink);
  URL.revokeObjectURL(href);
}

export function redirect(router, data, event, func, funcDefault) {
  if (func) {
    if (event.button === 1) window.open(func(data.id), "_blank");
    else router.push(func(data.id));
  } else funcDefault(data, event);
}
